import React, { useEffect, useState } from "react";
import "./KontaktiranjePravnogLica.scss";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import "../components/InputPoruka.scss";
import "../components/FormValidationsWarning.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config.json";

function KontaktiranjePravnogLica() {
  const { baseUrl, token } = config;
  const cookies = new Cookies(null, { path: "/" });
  const fizickoLice = cookies.get("fizickoLice");
  const navigate = useNavigate();

  const params = useParams();
  const date = new Date();
  const [pravnoLice, setPravnoLice] = useState({});

  useEffect(() => {
    async function getUser() {
      const response = await axios.get(
        `${baseUrl}/fizicko/pogledaj-posao/${params.id}`,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      setPravnoLice(response.data);
    }

    getUser();
  }, [params.id, baseUrl, token]);

  const formik = useFormik({
    initialValues: {
      porukaInput: "",
    },
    validationSchema: Yup.object({
      porukaInput: Yup.string().required("Niste unijeli poruku."),
    }),

    onSubmit: async (values) => {
      const { porukaInput } = values;
      const { status } = await axios.post(
        `${baseUrl}/fizicko/posalji-zahtjev`,
        {
          emailPravnogLica: pravnoLice.email,
          emailFizickoLica: fizickoLice.email,
          imeFizickogLica: fizickoLice.korisnickoIme,
          kontaktFizickogLica: fizickoLice.telefon,
          poruka: porukaInput,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (status === 200) {
        navigate("/");
      }
    },
  });
  return (
    <form id="kontaktiranje-pravnog-lica" onSubmit={formik.handleSubmit}>
      <Head title="Kontaktiranje Pravnog Lica" />
      <HeaderComponent />
      <h2>Novi zahtjevi za uslugama</h2>
      <ul>
        <li>{`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`}</li>
        <li>{pravnoLice.ime}</li>
        <li>{pravnoLice.telefon}</li>
      </ul>
      <label style={{ fontSize: "1.2rem" }}>Poruka</label>
      <textarea
        className="porukaKontaktiranjePravnogLica"
        type="text"
        id="porukaInput"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        label={formik.values.porukaInput}
      />
      {formik.touched.porukaInput && formik.errors.porukaInput ? (
        <span className="input-error" id="porukaInput-error">
          {formik.errors.porukaInput}
        </span>
      ) : null}

      <Button
        type="submit"
        marginLeft="0"
        marginTop="1.2rem"
        value="OK"
        btnType="submit"
      />
    </form>
  );
}

export default KontaktiranjePravnogLica;
